import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-988435a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "px-4 py-2 bg-white rounded-lg dark:bg-gray-800 mb-4",
  style: {"width":"80%"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "fisiologica-item" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "fisiologica-item" }
const _hoisted_7 = { class: "fisiologica-item" }
const _hoisted_8 = { class: "fisiologica-item" }

import AnamnesiFisiologicaEdit from "./AnamnesiFisiologicaEdit.vue";
import { patientStore } from '@/store/patient';
import { text } from '@fortawesome/fontawesome-svg-core';
import { storeToRefs } from 'pinia';
import { onMounted, ref } from 'vue';
import { Modal } from 'flowbite-vue'
import { reactive } from "vue";

interface ModalStatus {
  base: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FisiologicaSection',
  emits: ["save", "edit_fisiologica"],
  setup(__props, { emit }) {


const store = patientStore();
const { patient } = storeToRefs(store)

const isShowModal: ModalStatus = reactive({
  base: false,
});
function closeModal() {
  isShowModal.base = false;
  store.fetchAnamnesiFisiologica();

}

function getGravidanzeString(type: string) {
  if (patient.value.tbl_gravidanze == null)
    return '';

  const gravidanze = patient.value.tbl_gravidanze.filter(gr => gr.esito == type);
  const countGravidanze = gravidanze.length;
  if (gravidanze.length == 0)
    return '';

  let openingStatement = type == 'nascita' ? countGravidanze + ' con nascita nel ' : countGravidanze + ' esitate in aborto  ';

  openingStatement = `Gravidanze ${openingStatement}`;

  for (let gr in gravidanze) {
    const fineGravidanza = gravidanze[gr].fine_gravidanza;
    if (fineGravidanza !== null) {
      let year = fineGravidanza.toString().slice(0, 4);
      let suffix = gr as unknown as Number == countGravidanze - 1 ? ' , nel ' + year : ', ' + year;
      if (gravidanze[gr].sesso_bambino != null) {
        let articolo = 'un'
        if (gravidanze[gr].sesso_bambino == 'Femmina') {
          articolo = 'una'
        }
        suffix = suffix + ` di ${articolo} ${gravidanze[gr].sesso_bambino}`
      }
      openingStatement += suffix;
    }
  }
  return openingStatement;


}


function edit_anamnesiFisiologica() {
  isShowModal.base = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isShowModal.base === true)
      ? (_openBlock(), _createBlock(_unref(Modal), {
          key: 0,
          size: "7xl",
          onClose: _cache[0] || (_cache[0] = ($event: any) => (closeModal()))
        }, {
          body: _withCtx(() => [
            _createVNode(AnamnesiFisiologicaEdit, { onCancel: closeModal })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", {
        class: "w-full ml-3 space-y-1 textStyle list-disc list-inside dark:text-gray-400",
        onClick: edit_anamnesiFisiologica
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient)?.tbl_anamnesi_fisiologica, (value, key) => {
          return (_openBlock(), _createElementBlock("div", { key: key }, [
            (key != 'id_paziente' && key != 'id_anamnesi_log' && key != 'dataAggiornamento' && value != '01/01/2000' && value != '30/11/-0001' && value != '' && value != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (key.startsWith('data'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("p", _hoisted_4, [
                          _createTextVNode(_toDisplayString(_ctx.$t(key)) + ": ", 1),
                          _createElementVNode("span", null, _toDisplayString(new Date(value.toString()).toLocaleDateString('en-GB')), 1)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("p", _hoisted_6, [
                          _createTextVNode(_toDisplayString(_ctx.$t(key)) + ": ", 1),
                          _createElementVNode("span", null, _toDisplayString(value), 1)
                        ])
                      ]))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(getGravidanzeString('nascita')), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(getGravidanzeString('aborto')), 1)
        ])
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      onClick: edit_anamnesiFisiologica,
      style: {"float":"right","background-color":"#1A576E"},
      class: "inline-flex items-center mt-2 py-2.5 px-4 text-base font-medium text-center text-white rounded-lg focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-900 hover:bg-blue-800"
    }, _toDisplayString(_ctx.$t('Edit')), 1)
  ], 64))
}
}

})